(() => {
  'use strict';
  if (window.bmReviewHubInitialized) return;
  window.bmReviewHubInitialized = true;
  const selector = '[data-bm-review-hub]';
  const products = new Set(['gm3', 'ultra', 'nano', 'strap', 'velonix', 'legacy']);

  function track(action, root, detail = {}) {
    try {
      const shopify = window.Shopify;
      if (!shopify || !shopify.customerPrivacy || typeof shopify.customerPrivacy.analyticsProcessingAllowed !== 'function' || shopify.customerPrivacy.analyticsProcessingAllowed() !== true) return;
      if (shopify.theme && shopify.theme.role !== 'main') return;
      const data = { event: 'bm_review_interaction', action, locale: document.documentElement.lang || 'en', path: window.location.pathname, section_id: root.id, ...detail };
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(data);
      if (shopify.analytics && typeof shopify.analytics.publish === 'function') shopify.analytics.publish('bm_review_interaction', data);
    } catch (_) { /* Analytics must not prevent filtering or video playback. */ }
  }

  function productFromHash() {
    const value = window.location.hash.slice(1).toLowerCase();
    return products.has(value) ? value : null;
  }

  function initialize(root) {
    if (root.dataset.bmReviewReady) return;
    root.dataset.bmReviewReady = 'true';
    const cards = Array.from(root.querySelectorAll('[data-bm-review-card]'));
    const filters = Array.from(root.querySelectorAll('[data-bm-review-filter]'));
    const count = root.querySelector('[data-bm-review-count]');
    const empty = root.querySelector('[data-bm-review-empty]');
    const controls = root.querySelector('[data-bm-review-controls]');
    const filterBar = root.querySelector('.bm-rh__filters');
    const grid = root.querySelector('.bm-rh__grid');
    const navPrev = root.querySelector('[data-bm-review-nav="prev"]');
    const navNext = root.querySelector('[data-bm-review-nav="next"]');
    let activePlayer = null;
    let navFrame = null;

    function updateNavState() {
      if (!grid || !navPrev || !navNext) return;
      const maxScroll = grid.scrollWidth - grid.clientWidth;
      if (maxScroll <= 1) {
        navPrev.disabled = true;
        navNext.disabled = true;
        return;
      }
      navPrev.disabled = grid.scrollLeft <= 1;
      navNext.disabled = grid.scrollLeft >= maxScroll - 1;
    }

    function scheduleNavState() {
      if (navFrame) return;
      navFrame = requestAnimationFrame(() => {
        navFrame = null;
        updateNavState();
      });
    }

    function stepCarousel(direction) {
      if (!grid) return;
      const firstVisible = cards.find((card) => !card.hidden);
      const step = (firstVisible ? firstVisible.getBoundingClientRect().width : grid.clientWidth) + 24;
      grid.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    if (grid) {
      grid.addEventListener('scroll', scheduleNavState, { passive: true });
      window.addEventListener('resize', scheduleNavState);
    }

    function stopPlayer(restoreFocus = false) {
      if (!activePlayer) return;
      const previous = activePlayer;
      activePlayer = null;
      previous.iframe.remove();
      previous.close.remove();
      previous.poster.hidden = false;
      if (restoreFocus && !previous.card.hidden) previous.poster.focus();
    }

    function revealSelectedFilter(product) {
      const selected = filters.find((button) => button.dataset.bmReviewFilter === product);
      if (!selected || !filterBar || filterBar.scrollWidth <= filterBar.clientWidth) return;
      const viewport = filterBar.getBoundingClientRect();
      const button = selected.getBoundingClientRect();
      const left = viewport.left + filterBar.clientLeft;
      const right = left + filterBar.clientWidth;
      let offset = 0;
      if (button.left < left || button.width > filterBar.clientWidth) offset = button.left - left;
      else if (button.right > right) offset = button.right - right;
      // Scroll only this horizontal strip. Do not move the page or animate selection.
      if (offset) filterBar.scrollLeft += offset;
    }

    function updateFilter(product) {
      stopPlayer();
      let visible = 0;
      cards.forEach((card) => {
        card.hidden = product !== 'all' && card.dataset.product !== product;
        if (!card.hidden) visible += 1;
      });
      filters.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.bmReviewFilter === product));
      });
      if (count) {
        const label = (visible === 1 && root.dataset.countLabelSingular) ? root.dataset.countLabelSingular : (root.dataset.countLabel || 'videos shown');
        count.textContent = `${visible} ${label}`;
      }
      if (empty) empty.hidden = visible !== 0;
      revealSelectedFilter(product);
      if (grid) grid.scrollLeft = 0;
      scheduleNavState();
    }

    root.addEventListener('click', (event) => {
      const nav = event.target.closest('[data-bm-review-nav]');
      if (nav && root.contains(nav) && !nav.disabled) {
        stepCarousel(nav.dataset.bmReviewNav === 'next' ? 1 : -1);
        return;
      }
      const filter = event.target.closest('[data-bm-review-filter]');
      if (filter && root.contains(filter)) {
        const product = filter.dataset.bmReviewFilter;
        if (product !== 'all' && !products.has(product)) return;
        updateFilter(product);
        const nextHash = product === 'all' ? '' : '#' + product;
        if (product !== 'all' || productFromHash()) {
          window.history.replaceState(null, '', window.location.pathname + window.location.search + nextHash);
        }
        track('product_filter', root, { product });
        return;
      }
      const productLink = event.target.closest('[data-bm-review-product]');
      if (productLink && root.contains(productLink)) {
        const productCard = productLink.closest('[data-bm-review-card]');
        track('product_link', root, { product: productCard && productCard.dataset.product || '', product_handle: productLink.dataset.productHandle || '' });
      }
      const poster = event.target.closest('[data-bm-review-play]');
      if (!poster || !root.contains(poster) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const card = poster.closest('[data-bm-review-card]');
      const media = card && card.querySelector('[data-bm-review-media]');
      const videoId = card && card.dataset.videoId;
      if (!media || !/^[A-Za-z0-9_-]{11}$/.test(videoId || '')) return;
      event.preventDefault();
      stopPlayer();
      const iframe = document.createElement('iframe');
      const start = Math.max(0, Number.parseInt(card.dataset.videoStart, 10) || 0);
      const params = new URLSearchParams({ autoplay: '1', playsinline: '1', rel: '0' });
      if (start) params.set('start', String(start));
      iframe.className = 'bm-rh-card__player';
      iframe.title = card.dataset.videoTitle || 'YouTube video';
      iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?${params.toString()}`;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'bm-rh-card__close';
      close.textContent = root.dataset.closeLabel || 'Close video';
      close.addEventListener('click', () => stopPlayer(true));
      poster.hidden = true;
      media.append(iframe, close);
      activePlayer = { card, poster, iframe, close };
      close.focus({ preventScroll: true });
      track('video_play', root, { video_id: videoId, product: card.dataset.product, video_type: card.dataset.videoType });
      root.dispatchEvent(new CustomEvent('bm:review-video-play', {
        bubbles: true,
        detail: { videoId, product: card.dataset.product, type: card.dataset.videoType, sectionId: root.id }
      }));
    });
    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && activePlayer) {
        event.preventDefault();
        stopPlayer(true);
      }
    });
    function applyHash() {
      const product = productFromHash();
      if (!product) return;
      updateFilter(product);
      root.scrollIntoView({ block: 'start' });
    }
    window.addEventListener('hashchange', applyHash);
    root.bmReviewCleanup = () => {
      stopPlayer();
      window.removeEventListener('hashchange', applyHash);
      window.removeEventListener('resize', scheduleNavState);
      if (navFrame) cancelAnimationFrame(navFrame);
    };
    if (controls) controls.hidden = false;
    updateFilter(productFromHash() || 'all');
    if (productFromHash()) requestAnimationFrame(() => root.scrollIntoView({ block: 'start' }));
  }

  function scan(scope) {
    if (scope.matches && scope.matches(selector)) initialize(scope);
    scope.querySelectorAll(selector).forEach(initialize);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(selector).forEach((root) => {
      if (root.bmReviewCleanup) root.bmReviewCleanup();
    });
  });
})();
